import { MAINNET_XBTC_WCOIN } from '@aries/aptos-defi/config';
import axios from 'axios';
import { useMemo } from 'react';
import useSWR from 'swr';
import {
  OKX_APT_INVESTMENT_ID,
  OKX_USDC_INVESTMENT_ID,
  OKX_XBTC_INVESTMENT_ID,
} from './config';

export const useOkxEarn = () => {
  const { okxEarnApy: okxXBtcEarnApy } = useOkxEarnById(
    OKX_XBTC_INVESTMENT_ID,
  );

  const { okxEarnApy: okxUsdcEarnApy } = useOkxEarnById(
    OKX_USDC_INVESTMENT_ID,
  );

  const { okxEarnApy: okxAptEarnApy } = useOkxEarnById(
    OKX_APT_INVESTMENT_ID,
  );

  const okxEarnMap: Record<
    string,
    { apyPct: number; url: string } | undefined
  > = useMemo(() => {
    return {
      [MAINNET_XBTC_WCOIN]: {
        apyPct: okxXBtcEarnApy,
        url: 'https://web3.okx.com/earn/product/aries-markets-aptos-xbtc-25019#source=activitypage&activitySourcePage=aptos',
      },
    };
  }, [okxXBtcEarnApy]);

  return {
    okxEarnMap,
    okxUsdcEarnApy,
    okxAptEarnApy,
  };
};

export const useOkxEarnById = (investmentId: number) => {
  const { data: okxEarnApy = 0 } = useSWR(
    ['OKX_XBTC_INVESTMENT_BONUS', investmentId],
    async () => {
      const investmentBonusStats = await axios.get<{
        apy: number;
      }>(
        `https://aptos-app-git-feat-api-cors-port-fi.vercel.app/api/okx-apy`,
        {
          params: {
            investmentId,
          },
        },
      );
      return investmentBonusStats.data.apy * 100;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      errorRetryCount: 1,
    },
  );

  return {
    okxEarnApy,
  };
};
